import { render, staticRenderFns } from "./FrontdatasModule.vue?vue&type=template&id=ac656c26"
import script from "./FrontdatasModule.vue?vue&type=script&lang=js"
export * from "./FrontdatasModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports